import { Fragment, PropsWithChildren, useMemo } from "react";
import Provider, { createProviderToken, useProvider } from "../../../../shared/provider";
import { ConnectorTypes } from "../../../../shared/types/common";
import Loader from "../../../common/components/loader/Loader";
import { useServerConfiguration } from "../../../core/configuration/components/ServerConfigurationProvider";
import { useGetZoomMetadata } from "../api/useGetZoomMetadata";

export interface ZoomConfiguration {
  isZoomEnabled: boolean;
  isZoomNative: boolean;
  isZoomPca: boolean;
}

const providerToken = createProviderToken<ZoomConfiguration>('zoomConfiguration');

export function useZoomConfiguration(): ZoomConfiguration {
  return useProvider(providerToken);
}

interface Props { }

function ZoomConfigurationProvider(props: PropsWithChildren<Props>) {
  const serverConfig = useServerConfiguration();

  const isZoomEnabled = serverConfig.connectorTypes.includes(ConnectorTypes.Zoom);

  const { isLoading, data } = useGetZoomMetadata({ enabled: isZoomEnabled, staleTime: Infinity });

  const zoomConfiguration = useMemo<ZoomConfiguration>(() => {
    const isZoomNative = isZoomEnabled && !!data?.asteriskEnabled;

    return {
      isZoomEnabled,
      isZoomNative,
      isZoomPca: isZoomEnabled && !isZoomNative,
    }
  }, [isZoomEnabled, data?.asteriskEnabled])

  return (
    <Fragment>
      {isLoading && <Loader />}
      {!isLoading && (
        <Provider provide={providerToken} value={zoomConfiguration}>
          {props.children}
        </Provider>
      )}
    </Fragment>
  )
}

export default ZoomConfigurationProvider
